module.exports = __webpack_public_path__ + "media/packs/images/flags/AZ-7f2cdb55658cb14071af10c2a5cf83a7.svg";